import { Box, Grid2 as Grid, Paper, Typography } from "@mui/material";
import useScreenSize from '../../../../hooks/useScreenSize';

import field from "../../../../assets/field.png";

type PromoProps = {
    size?: number
}

const PromoWidget = ({ size = 8 }: PromoProps) => {
    const screenSize = useScreenSize();

    return (
        <Grid size={screenSize.width < 1200 ? 12 : size}>
            <Paper elevation={5} sx={{ display: 'flex', minHeight: 230, gap: 1 }}>
                <Box flex="0 0 45%" overflow="hidden" position="relative">
                    <img 
                        src={field}
                        alt="cover-image"
                        style={{
                            position: 'absolute',
                            left: 0,
                            top: 0,
                            height: '100%',
                            width: '100%',
                            objectFit: 'cover',
                            filter: 'blur(4px)'
                        }}
                    />
                </Box>
                <Box p={2} width="50%" display="flex" flexDirection="column" gap={1}>
                    <Typography variant="h6">Reach Your Target Audience!</Typography>
                    <Typography>
                        Launch your next ad campaign with Statrat to reach baseball players
                        around the world! Fine tune your ad to target the exact demographic
                        you're looking for and gain new users today!
                    </Typography>
                </Box>
            </Paper>
        </Grid>
    )
}

export default PromoWidget;
